const resources = {
    signInButton: 'Ouvrir une session',
    signInText: ' pour voir votre liste de favoris.',
    yourLoves: 'Vos favoris apparaîtront ici.',
    yourSavedItems: 'Essentiels sur vos listes'
};

export default function getResource(label) {
    return resources[label];
}
